export const URL_SEARCHER =
    process.env.ENVIRONMENT === "PDN"
        ? "https://lk9tx38w5a.execute-api.us-east-1.amazonaws.com/pdn/search/api/v1/search-article"
        : process.env.ENVIRONMENT === "QA"
            ? "https://153ql605pj.execute-api.us-east-1.amazonaws.com/qa/search/api/v1/search-article"
            : "https://nlhip4kxl4.execute-api.us-east-1.amazonaws.com/dev/search/api/v1/search-article";

export const URL_ARTICLE_RATING =
    process.env.ENVIRONMENT === "PDN"
        ? "https://lk9tx38w5a.execute-api.us-east-1.amazonaws.com/pdn/rating/api/v1/rating-article"
        : process.env.ENVIRONMENT === "QA"
            ? "https://153ql605pj.execute-api.us-east-1.amazonaws.com/qa/rating/api/v1/rating-article"
            : "https://nlhip4kxl4.execute-api.us-east-1.amazonaws.com/dev/rating/api/v1/rating-article";